import { MembroUnidadeGetAllItemDTO } from "model/reino/MembroUnidadeGetAllItemDTO";
import { Unidade } from "model/reino/Unidade";
import { RootState } from "store/store";
import { EstadoRequisicao } from "store/types";
import { convertArrayToObject } from "util/collections";

export class UnidadesResponsaveisSelector {
  static readonly estado = (it: RootState) => it.unidadesResponsaveis.estado;
  static readonly isCarregando = (it: RootState) => it.unidadesResponsaveis.estado === EstadoRequisicao.CARREGANDO;
  static readonly erros = (it: RootState) => it.unidadesResponsaveis.erros;
  static readonly hasErros = (it: RootState) => it.unidadesResponsaveis.estado === EstadoRequisicao.FALHOU;
  
  static readonly unidades = (it: RootState) => it.unidadesResponsaveis.unidadesResponsaveis;
  static readonly unidade = (idUnidade: number) => (it: RootState): Unidade|undefined => {
    const unidades = convertArrayToObject(it.unidadesResponsaveis.unidadesResponsaveis, "id");
    return unidades[idUnidade];
  }

  static readonly responsaveisTecnicos = (it: RootState) => it.unidadesResponsaveis.responsaveisTecnicos;
  static readonly responsavelTecnico = (idResponsavelTecnico: number) => (it: RootState): MembroUnidadeGetAllItemDTO | undefined => {
    const membrosUnidade = convertArrayToObject(it.unidadesResponsaveis.responsaveisTecnicos, "id");
    return membrosUnidade[idResponsavelTecnico];
  }
}